export const SET_STATUSTEMPLATE = 'WA/SET_STATUSTEMPLATE'
export const SET_STATUSTEMPLATES = 'WA/SET_STATUSTEMPLATES'
